var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticStyle:{"flex":"0 0 auto"}},[_c('div',{staticClass:"text-center white--text"},[_vm._v(_vm._s(_vm.projectsName))]),_c('canvas',{attrs:{"id":'canvas' + _vm.projectId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }